import { render, staticRenderFns } from "./MenuNoviCas.vue?vue&type=template&id=a6b5207e&"
import script from "./MenuNoviCas.vue?vue&type=script&lang=js&"
export * from "./MenuNoviCas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports